import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Domain_LocalResourcesDefinition  {
    _originalTypeClassName = "zvelton_Backoffice.BO.Domain_LocalResourcesDefinition";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Domain_LocalResourcesDefinition.translate = translateService;
}
this.CoreBO_Res_ASSOC_DatabaseType_DatabaseConnectionInfo_Type = null;
this.CoreBO_Res_ASSOC_UserAccount_SubscriptionAccess_User = null;
this.Res_ENUM_MCP_AuthenticationType_Basic = null;
this.Res_ENUM_MCP_AuthenticationType_ApiKey = null;
this.Res_ENUM_MCP_AuthenticationType_ForwardHeader = null;
this.Res_ENUM_MCP_AuthenticationType_Oauth2 = null;
this.Res_ENUM_MCP_AuthenticationType_Certificate = null;
this.Res_ENUM_MCP_AuthenticationType_None = null;
this.BillingBO_Res_ASSOC_Subscription_PaymentEntry_Subscription = null;
this.BillingBO_Res_ASSOC_APIKey_UsageEntry_Key = null;
this.BillingBO_Res_ASSOC_Pricelist_Application_Pricelist = null;
this.BillingBO_Res_ASSOC_Pricelist_Subscription_DefaultPricelist = null;
this.BillingBO_Res_ASSOC_Pricelist_UserAccount_DefaultSystemPricelist = null;
this.Res_ENUM_PaymentStatus_Pending = null;
this.Res_ENUM_PaymentStatus_Completed = null;
this.Res_ENUM_PaymentStatus_Failed = null;
}

static translate: TranslateService;
_key: any;
CoreBO_Res_ASSOC_DatabaseType_DatabaseConnectionInfo_Type:any;
CoreBO_Res_ASSOC_UserAccount_SubscriptionAccess_User:any;
Res_ENUM_MCP_AuthenticationType_Basic:any;
Res_ENUM_MCP_AuthenticationType_ApiKey:any;
Res_ENUM_MCP_AuthenticationType_ForwardHeader:any;
Res_ENUM_MCP_AuthenticationType_Oauth2:any;
Res_ENUM_MCP_AuthenticationType_Certificate:any;
Res_ENUM_MCP_AuthenticationType_None:any;
BillingBO_Res_ASSOC_Subscription_PaymentEntry_Subscription:any;
BillingBO_Res_ASSOC_APIKey_UsageEntry_Key:any;
BillingBO_Res_ASSOC_Pricelist_Application_Pricelist:any;
BillingBO_Res_ASSOC_Pricelist_Subscription_DefaultPricelist:any;
BillingBO_Res_ASSOC_Pricelist_UserAccount_DefaultSystemPricelist:any;
Res_ENUM_PaymentStatus_Pending:any;
Res_ENUM_PaymentStatus_Completed:any;
Res_ENUM_PaymentStatus_Failed:any;




}